import "./Platform.css"
export default function DastresiTxt(props) {
    return props.ModuleDetails.map((md, index) => {
        return <span className="dastresi" style={
            { color: md.TitleForeColor, backgroundColor: md.BackgroundColor }
        } onClick={() =>
            (window.location.href = md.URL)
        }>
            {" "}
            {md ? md.Title : ""}
        </span>
    })
}